import styled from "styled-components";

export const ToCheckerWrapper = styled.div`
  .scannerWrapper video {
    position: relative;
  }
  .scannerWrapper .drawingBuffer {
    position: relative !important;
  }
  .mt-25 {
    margin-top: 25px !important;
  }
  .mb-25 {
    margin-bottom: 25px !important;
  }

  .boxesWraper {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 25px;
  }
  .box {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 18px;
  }
  .checked {
    background: #e2ffbc;
  }
  .pending {
    background-color: #cdcdcd;
  }
`;
